export const state = {
    errorLog: []
};

export const reducer = {
    logError(state, action) {
        if ('errorLog' in (state || {}) && Array.isArray(state.errorLog)) {
            state.errorLog.push(action?.payload);

            if (state.errorLog.length > 10) {
                state.errorLog.shift();
            }
        }
    },
    clearErrorLog(state) {
        if ('errorLog' in (state || {}) && Array.isArray(state.errorLog)) {
            state.errorLog = [];
        }
    }
};
